import React from 'react';
import {MobileMenu} from '../HeaderMobileMenu/HeaderMobileMenu';
import {HeaderLogo} from '../HeaderLogoBlock/HeaderLogoBlock';
import {HeaderMenu} from '../HeaderMenu/HeaderMenu';
import {HeaderActions} from '../HeaderActions/HeaderActions';

export default function HeaderLayoutRight({ links, item_count = '', settings }) {
    return (
        <div className={`container flex items-center lg:items-${settings.section.header_text_position_desktop} relative`}>
            <MobileMenu link_list={links} settings={settings}/>
            <HeaderActions item_count={item_count} settings={settings}/>
            <HeaderMenu link_list={links} settings={settings} />
            <HeaderLogo settings={settings} />
        </div>
    );
}